import { z } from 'zod';

export const TimePostponementFormSchema = z.object({
  amount: z.coerce
    .number({ message: 'กรุณาระบุระยะเวลา' })
    .min(15, { message: 'กรุณาระบุระยะเวลาไม่น้อยกว่า 15 นาที' })
    .max(120, { message: 'กรุณาระบุระยะเวลาไม่เกิน 120 นาที' }),
  remark: z
    .string()
    .trim()
    .min(1, { message: 'กรุณาระบุเหตุผลในการเลื่อน' })
    .max(255, { message: 'ความยาวต้องไม่เกิน 255 ตัวอักษร' }),
});

export type TimePostponementFormType = z.infer<typeof TimePostponementFormSchema>;
